import { addBusinessDays, subBusinessDays, addDays, subDays } from "date-fns";

export function strClean(value: string): string {
  const alphanumericRegex = /[\W_]/g;
  return value.replaceAll(alphanumericRegex, "").toLocaleLowerCase();
}

export function strIncludes(compareStr: string, testStr: string): boolean {
  return strClean(compareStr).includes(strClean(testStr));
}

export function adjustDateByDays(
  date: Date,
  days: number,
  isBusiness: boolean = false,
): Date {
  if (days === 0) {
    return date;
  }

  if (days < 0) {
    if (isBusiness) {
      return subBusinessDays(date, Math.abs(days));
    }
    return subDays(date, Math.abs(days));
  }

  if (isBusiness) {
    return addBusinessDays(date, days);
  }

  return addDays(date, days);
}
